import { styled, css } from 'styled-components';
import { Flex } from '../Flex.js';
import { cssVar } from '../../theme/variables.js';

const ConnectionStatusDot = styled.div.withConfig({
  displayName: "StatusBadge__ConnectionStatusDot",
  componentId: "sc-5221a509-0"
})([
  `height:0.5rem;width:0.5rem;border-radius:50%;background:var(--content-color);`
]);
const StatusText = styled.span.withConfig({
  displayName: "StatusBadge__StatusText",
  componentId: "sc-5221a509-1"
})([
  `font-weight:500;color:rgba(0,0,0,0.7);`
]);
const Container = styled(Flex).attrs({
  alignItems: "center"
}).withConfig({
  displayName: "StatusBadge__Container",
  componentId: "sc-5221a509-2"
})([
  `border-radius:10px;height:2rem;padding:0 0.5rem;gap:0.5rem;color:`,
  `;`,
  `{font-size:0.875rem;}`,
  ` `,
  ``
], cssVar["color-text-secondary"], StatusText, ({ size }) => {
  if (size === "sm") {
    return css([
      `height:1.5rem;padding:0 0.375rem;border-radius:8px;`,
      `{font-size:0.75rem;}`
    ], StatusText);
  }
}, (p) => {
  switch (p.status) {
    case "grey":
      return css([
        `--content-color:#686868;background:`,
        `;`,
        `{color:`,
        `;}`
      ], cssVar["color-bg-quinary"], StatusText, cssVar["color-text-secondary"]);
    case "orange":
      return css([
        `--content-color:#ff9900;background:#fff0cc;`
      ]);
    case "red":
      return css([
        `--content-color:#ff0000;background:#ffcccc;`
      ]);
    case "green":
      return css([
        `--content-color:#24cd2b;background:#d3f5d5;`
      ]);
  }
});
const StatusBadge = {
  Root: Container,
  Dot: ConnectionStatusDot,
  Text: StatusText
};

export { StatusBadge };
//# sourceMappingURL=StatusBadge.js.map
